export type TaskSource = 'project_plan' | 'action_item';

export interface UnifiedTask {
  id: string;
  projectId: string;
  projectName: string;
  name: string;
  description: string;
  ownerId: string;
  dueDate: string;
  status: string;
  priority: string;
  source: TaskSource;
  phaseId: string;
  phaseName: string;
  originalTask: ProjectItemInterface | ProjectActionItem;
}

export const convertProjectItemToUnifiedTask = (item: ProjectItemInterface, project: ProjectInterface): UnifiedTask => {
  const phase = project.phases?.find(p => p.id === item.phase_id);
  // Only use description if it's different from name and not empty
  const description = item.description && item.description.trim() !== '' && item.description !== item.name ? item.description : '';
  
  // Fix display name: replace "Phase1" with "Phase" for UI, but keep original phase_id for backend
  const displayPhaseName = phase?.name === 'Phase1' ? 'Phase' : (phase?.name || '');
  
  return {
    id: item.id,
    projectId: item.project_id,
    projectName: project.name,
    name: item.name,
    description: description,
    ownerId: item.owner_id,
    dueDate: item.due_date,
    status: item.status,
    priority: item.priority,
    source: 'project_plan',
    phaseId: item.phase_id,
    phaseName: displayPhaseName,
    originalTask: item
  };
};

export const convertActionItemToUnifiedTask = (item: ProjectActionItem, project: ProjectInterface): UnifiedTask => {
  const phase = project.phases?.find(p => p.id === item.phase_id);
  // Only use description if it's different from name and not empty
  const description = item.description && item.description.trim() !== '' && item.description !== item.name ? item.description : '';
  
  // Fix display name: replace "Phase1" with "Phase" for UI, but keep original phase_id for backend
  const displayPhaseName = phase?.name === 'Phase1' ? 'Phase' : (phase?.name || '');
  
  return {
    id: item.id,
    projectId: item.project_id,
    projectName: project.name,
    name: item.name,
    description: description,
    ownerId: item.owner_id || '',
    dueDate: item.due_date || '',
    status: item.status,
    priority: item.priority || 'LOW',
    source: 'action_item',
    phaseId: item.phase_id,
    phaseName: displayPhaseName,
    originalTask: item
  };
}; 